import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import SocketService from '../../services/socket';
import { getCookie } from '../../services';
import { RootState } from '../../store';
import SocketContext from './index';
import SocketState from './state';

const SocketProvider = ({ children }: any) => {
  const socketServiceRef = useRef<SocketService | null>(null);
  const { token } = useSelector((state: RootState) => state.clickState);

  const [value, setValue] = useState<SocketState>(new SocketState());

  useEffect(() => {
    const currentToken = token || getCookie();

    if (!currentToken) {
      socketServiceRef.current?.socketInstance.disconnect();
      socketServiceRef.current = null;
      return;
    }

    socketServiceRef.current?.socketInstance.disconnect();
    socketServiceRef.current = new SocketService(setValue, currentToken);

    return () => {
      socketServiceRef.current?.socketInstance.disconnect();
      socketServiceRef.current = null;
    };
  }, [token]);

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
};

export default SocketProvider;
